

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AtomizerJobsData,
  getInlineImage,
  updateCmDomains,
  deleteDataCM,
  fetchAttachmentURL,
} from "../../API/api";
import { Skeleton } from "antd";
import Styles from "./Styles.module.css";
import {
  filterDomainsForComponent,
  replaceContentEditableText,
} from "../../utils";
import ReactQuill, { Quill } from "react-quill";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizHeader from "../VizHeader/VizHeader";
import VizButton from "../VizButtons/VizButton";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { Card } from "antd";
import { questionTypeCM, questionTypeCMObj, questionTypeCM2, questionTypeCMObj2 } from "../../Constants";
import { toast } from "react-toastify";
import { Select } from 'antd'

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};

const relevantData = [
  { label: "All", value: "All", name: "All" },
  { label: "Non-Misc", value: "Non-Misc", name: "Non-Misc" },
  { label: "Reusable Thread QA", value: "Reusable Thread QA", name: "Reusable Thread QA" }
];
const DataRenderer = ({ data, imageData, refreshFunc, textFind, onChangeTextFind, totalMatches, textReplace, onChangeTextPlace, onButtonReplace, getHighlightedText }) => {
  const drawerState = useSelector((state) => state.drawer);
  const [text, setText] = useState(data.para);
  const [ques, setQues] = useState(data.head);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [relevantval, setReleventVal] = useState(data.labels === null ? [] : data.threadType === 'THREAD' ? questionTypeCMObj[data.labels] : questionTypeCMObj2[data.labels]);

  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const onClickButton = () => {
    setIsLoading(true);
    let payload = { ...data };
    payload.para = text;
    payload.head = ques;
    payload.labels = relevantval.length === 0 ? null : relevantval.value;
    let newPayload = {
      soId: null,
      domainIds: null,
      data: [payload],
    };
    updateCmDomains(newPayload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(successMsg(res.data.message));
        data.para = text;
        data.head = ques;
        data.labels = payload.labels;
        setIsLoading(false);
        // refreshFunc();
        setIsEdit(false);
      }
    });
  };

  const addImages = (str) => {
    let imagArr = Object.keys(imageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replaceAll(replacedContent, imgTag);
      }
    }
    return str;
  };
  // const onChangeRelevant = (val) => {
  //  const updateVal =data.labels === null ? questionTypeCMObj : data.threadType === 'THREAD' ? questionTypeCMObj : questionTypeCMObj2

  //   setReleventVal(val);
  // };
  const onChangeRelevant = (val) => {
    const updateVal = data.labels === null
      ? questionTypeCMObj
      : data.threadType === 'THREAD'
        ? questionTypeCMObj
        : questionTypeCMObj2;

    const selectedObj = updateVal.find(item => item.value === val);

    // console.log("Selected Object:", selectedObj);
    setReleventVal(selectedObj); // or just val, depending on what you need
  };
  // console.log("log",questionTypeCM,questionTypeCM2,data)
  // console.log("relevantval",relevantval)
  return (
    <>
      <div className={Styles.cardcontainer}>
        {!isEdit && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className={Styles.cardHeading} style={{ color: "#0c0d0c" }}>{data.labels !== null && data.threadType === 'THREAD' ? questionTypeCM[data.labels] : questionTypeCM2[data.labels]} {data.threadDate} {data.threadType === 'THREAD' ? "(Thread)" : "(Reusable Thread QA)"}</span>
              {!drawerState.obj.indexed && (
                <span
                  style={{
                    // display: "flex",
                    // justifyContent: "end",
                    color: "#999",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-edit"
                    style={{ fontSize: '20px', color: '#ACB6C6', cursor: 'pointer' }}
                    onClick={() => setIsEdit(true)}
                  // style={{ cursor: "pointer" }}
                  ></i>
                </span>
              )}
            </div>
            <div
              style={{
                marginBottom: ".2rem",
                display: "flex",
                alignItems: "baseline",
                // justifyContent:'space-between'
              }}
            >
              {data.head.length !== 0 && <span className={Styles.cardHeading}>HEAD:</span>}
              {data.head.length !== 0 && textFind === '' && <span style={{ width: "95%" }}>&nbsp;{data.head}</span>}
              {data.head.length !== 0 && textFind !== '' && getHighlightedText(data.head, textFind)}
            </div>
            <div>
              <span className={Styles.cardHeading}>DATA:&nbsp;</span>
              {textFind === '' && <span
                dangerouslySetInnerHTML={{
                  __html: replaceContentEditableText(addImages(data.para)),
                }}
                style={{ fontSize: "14px" }}
              ></span>}
              {textFind !== '' && <span
                style={{ fontSize: "14px" }}
              >{getHighlightedText(data.para, textFind)}</span>}
            </div>
          </>
        )}
        {isEdit && (
          <>
            {data.head.length !== 0 && <div
              style={{
                marginBottom: ".2rem",
                display: "flex",
                alignItems: "baseline",
                width: "100%",
              }}
            >
              {/* <input
              type="text"
              value={ques}
              style={{
                width: "100%",
                border: "1px solid lightgrey",
                borderRadius: "3px",
                height: "40px",
              }}
              onChange={(e) => setQues(e.target.value)}
            /> */}
              <textarea wrap="soft"

                style={{
                  border: '1px solid lightgrey',
                  width: '100%',
                  fontSize: '12px',
                  borderRadius: '3px',
                  outline: 'none',
                  resize: 'none',
                  height: '30px',
                  // height:"30px",
                  // alignItems:"center",
                  lineHeight: '30px',   // centers text vertically
                  padding: '0 8px',
                }}
                // style={{ border: '1px solid rgb(224, 226, 230)', width: '200px', padding: '12px', borderRadius: '6px', outline: 'none',resize: "none",height:"30px" }} 
                type={"text"}
                value={ques}
                onChange={(e) => setQues(e.target.value)}
              // minRows={1} 
              />
            </div>}
            <div>
              <ReactQuill
                theme="snow"
                value={text}
                onChange={(e) => setText(e)}
              />
            </div>
            {!isLoading &&
              <div
                className="mt-1"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "baseline",
                }}
              >
                {/* background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
 // background: " #F6F7F8", */}
                <div style={{ width: "143px" }}>
                  <span style={{ width: "200px" }}>
                    {/* <MultiSelectCmTwo
                    value={relevantval}
                    onChangeFunc={onChangeRelevant}
                    isMulti={false}
                    options={data.labels === null ? questionTypeCMObj : data.threadType === 'THREAD' ? questionTypeCMObj : questionTypeCMObj2}
                  /> */}
                    <Select
                      style={{ width: "100%", height: "40px" }}
                      value={relevantval?.value}
                      onChange={onChangeRelevant}
                      options={
                        data.labels === null
                          ? questionTypeCMObj
                          : data.threadType === "THREAD"
                            ? questionTypeCMObj
                            : questionTypeCMObj2
                      }
                    />
                  </span>
                </div>
                &nbsp;
                {!isLoading &&
                  <button
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: ' 0px 1px 2px 0px #1018280D',
                      color: '#2A364A',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: " #F6F7F8",
                      marginBottom: '14px',
                      fontWeight: 400,
                      border: " 1px solid #E0E2E6",
                      cursor: "pointer",
                      //  font-weight: 400;			
                    }}
                    onClick={() => setIsEdit(false)}
                  >
                    Cancel
                  </button>}
                &nbsp;
                {!isLoading && <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    cursor: "pointer",
                    //  font-weight: 400;			
                  }}
                  onClick={onClickButton}>
                  Save
                </button>}
              </div>}
          </>
        )}
      </div>

    </>
  );
};
const SubContainer = ({ data, imageData, refreshFunc, textFind, textReplace, totalMatches, onButtonReplace, onChangeTextFind, onChangeTextPlace, getHighlightedText, isRelevant }) => {
  const [origData, setOrigData] = useState(data);
  const [daata, setDaata] = useState(data);
  const [filterVal, setFilterVal] = useState({ name: "All", value: "All", label: "All" })
  const drawerState = useSelector((state) => state.drawer);
  const deleteContents = () => {
    let payload = {
      type: "para",
      data: [{ docId: data[0].docId }],
    };
    deleteDataCM(payload).then((res) => {
      if (res === undefined) return;
      refreshFunc();
    });
  };
  const onChangeFilter = (data) => {
    const selectedObj = relevantData.find(item => item.value === data);
    console.log("data", selectedObj)
    setFilterVal(data);
    // setFilterVal(selectedObj);
    setDaata([]);
    if (data.name === "All" || data === "All") {
      setTimeout(() => {
        setDaata(origData)
      }, 100);
    }
    if (data.name === "Non-Misc" || data === "Non-Misc") {
      // console.log("original data",origData)
      let newData = origData.filter(obj => {
        if (obj.labels == '0' || obj.labels == '2') {
          return obj;
        }
      })
      setTimeout(() => {
        setDaata(newData)
      }, 100);
    }
    if (data.name === "Reusable Thread QA" || data === "Reusable Thread QA") {
      let newData = origData.filter(obj => {
        if (obj.threadType === 'REUSABLE_THREAD_QA') {
          return obj;
        }
      })
      setTimeout(() => {
        setDaata(newData)
      }, 100);
    }
  }


  useEffect(() => { onChangeFilter(isRelevant) }, [isRelevant])
  console.log("isRelevant", isRelevant)
  return (
    <>{
      daata?.length > 0 && <Card className="mt-2" style={{ boxShadow: "7px 7px 20px lightgrey" }}>
        <div
          style={{
            fontSize: "20px",
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ marginTop: '8px', width: "140px" }}>
            <Select
              style={{ width: "100%" }}
              value={filterVal}
              onChange={onChangeFilter}
              placeholder="Select Option"
              options={[
                { name: "All", value: "All", label: "All" },
                { name: "Non-Misc", value: "Non-Misc", label: "Non-Misc" },
                {
                  name: "Reusable Thread QA",
                  value: "Reusable Thread QA",
                  label: "Reusable Thread QA",
                },
              ]}
              defaultValue={filterVal}
            />
            {/* <MultiSelectCmTwo
              isMulti={false}
              value={filterVal}
              onChangeFunc={onChangeFilter}
              options={[
                { name: "All", value: "All", label: "All" },
                { name: "Non-Misc", value: "Non-Misc", label: "Non-Misc" },
                {
                  name: "Reusable Thread QA",
                  value: "Reusable Thread QA",
                  label: "Reusable Thread QA",
                },
              ]}
            /> */}

            {/* <Select
              style={{ width: "100%" }}
              placeholder="Select Option"
              value={filterVal}
              onChange={onChangeFilter}// can be string or object depending on your state
              // onChange={(v) => {
              //   // Find the full object
              //   const selectedObj = relevantData.find(item => item.value === v);
              //   setRelevant(selectedObj);
              //   // console.log("Selected object:", selectedObj);
              // }}
                options={[
                { label: "All", value: "All" },
                { label: "Non-Misc", value: "Non-Misc" },
                { label: "Reusable Thread QA", value: "Reusable Thread QA" },
              ]}
            /> */}
          </div>
          {!drawerState.obj.indexed && (
            <div>
              {" "}
              <i onClick={() => deleteContents()} className="fa fa-trash" style={{ cursor: 'pointer' }}></i>
            </div>
          )}
        </div>
        {daata.map((obj) => {
          return (
            <DataRenderer
              data={obj}
              refreshFunc={refreshFunc}
              imageData={imageData}
              onButtonReplace={onButtonReplace}
              getHighlightedText={getHighlightedText}
              textFind={textFind}
            />
          );
        })}
      </Card>
    }
    </>
  );
};
export default function ReviewContent3() {
  const [nestedArray, setNestedArray] = useState([])
  const drawerState = useSelector((state) => state.drawer);
  const [textFind, setTextFind] = React.useState('');
  const [textReplace, setTextReplace] = React.useState('');
  const [totalMatches, setTotalMatches] = useState(0);
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\'"]/g, '\\$&');
  };
  const escapedSearchString = React.useMemo(() => {
    return textFind ? escapeRegExp(textFind) : '';
  }, [textFind]);


  const regex = React.useMemo(() => {
    return escapedSearchString ? new RegExp(escapedSearchString, 'gi') : null;
  }, [escapedSearchString]);
  const [processedData, setProcessedData] = useState([]);

  const [origData, setOrigData] = useState([]);
  const [data, setData] = useState([]);
  const [isRelevant, setRelevant] = useState({
    name: "All",
    value: "All",
    label: "All",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [inlineImageData, setInlineImageData] = useState("");
  const dispatch = useDispatch();
  const { isDrawerOpen } = bindActionCreators(Actions, dispatch);
  const [refreshData, setRefreshData] = useState("");
  const fetchData = () => {
    setIsLoading(true);
    drawerState.payload.data[0].page = pageNo;
    AtomizerJobsData(drawerState.payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        if (res.data.data.inlineImages.length > 0) {
          getInlineImage(res.data.data.inlineImages).then((res2) => {
            if (res2 === undefined) return;
            if (res2.data.success) {
              setInlineImageData(res2.data.data);
            }
          });
        }
        setData(res.data.data.parsedData);
        flattenArray(res.data.data.parsedData);
        setOrigData(res.data.data.parsedData);
        setIsLoading(false);
      }
    });
  };
  // const onChangeRelevant = (option) => {
  //   setRelevant(option);
  //   if(option.name==='All'){
  //     setData(origData);
  //   }
  //   if(option.name==='Relevant'){
  //    let newData = origData.filter(obj=>{
  //     if(obj.relevant === 1){
  //       return obj;
  //     }
  //    })
  //    setData(newData);
  //   }
  //   if(option.name==='Non-Relevant'){
  //     let newData = origData.filter(obj=>{
  //      if(obj.relevant === 0){
  //        return obj;
  //      }
  //     })
  //     setData(newData);
  //    }

  // };
  const refresh = () => {
    setRelevant({
      name: "All",
      value: "All",
      label: "All",
    });
    setRefreshData(Math.random() * 10);
  };
  // const highlightText = (text, isTargeted = false) => {
  //   if (!text) return { highlightedText: text, count: 0 };
  //   const matches = text.match(regex);
  //   const count = matches ? matches.length : 0;
  //   // const highlightedText = text.replace(regex, (match) => `<span style="background-color: yellow">${match}</span>`);
  //   const element = document.getElementById('textRef')
  //   const highlightedText = text.replace(regex, (match) => {
  //     const highlightStyle = isTargeted ?
  //       'background-color: yellow; font-weight: bold; color: red;' :
  //       'background-color: yellow;font-size:22px';
  //     return `${textReplace || match}`;
  //   });
  //   return { highlightedText, count };
  // };

  const highlightText = (text, searchTerm) => {
    if (!searchTerm) return { highlightedText: text, count: 0 };
    const escapedSearchTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    const matches = text.match(regex);
    const highlightedText = text.replace(regex, '<span id="textRef" style="font-weight: bold; background-color: yellow;">$1</span>');
    return { highlightedText, count: matches ? matches.length : 0 };
  };

  // function highlightText(text, highlight) {
  //   // Function to escape special characters for use in a regular expression
  //   function escapeRegExp(string) {
  //     return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  //   }
  //   // Escape the highlight text to safely use in regex
  //   const escapedHighlight = escapeRegExp(highlight);
  //   // Split the text based on the highlight term, using a case-insensitive regex
  //   const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));
  //   return (
  //     <span style={{ width: '95%' }}>
  //       {
  //         parts.map((part, i) =>
  //           <span
  //             key={i}
  //             style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', backgroundColor: 'yellow' } : {}}
  //             dangerouslySetInnerHTML={{ __html: replaceContentEditableText(onHandleInlineImages(part)) }}
  //           />
  //         )
  //       }
  //     </span>
  //   );
  // }



  function onHandleInlineImages(str) {
    let imagArr = Object.keys(inlineImageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replaceAll(replacedContent, imgTag);
      }
    }
    return str;
  }
  function getHighlightedText(text, highlight) {
    if (!highlight) {
      return text; // Return the original text if no highlight term is provided
    }

    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return (
      <span style={{ width: '95%' }}>
        {
          parts.map((part, i) =>
            <span
              key={i}
              dangerouslySetInnerHTML={{ __html: replaceContentEditableText(onHandleInlineImages(part)) }}
              style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', backgroundColor: 'yellow' } : {}}
            >
            </span>
          )
        }
      </span>
    );
  }
  const onChangeTextFind = (e) => {
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextFind(trimmedValue)
    //   // setTextFind(e.target.value.replace(/\s/g, ''));
    //   let totalCount = 0;
    //   const processed = nestedArray.map((item) => {
    //     let newItem = { ...item };
    //     const headResult = highlightText(item.head);
    //     const updatedHead = headResult.highlightedText.replace(/(<span id="textRef">)(.*?)(<\/span>)/gi, (match, p1, p2, p3) => {
    //       const { highlightedText, count } = highlightText(p2);
    //       totalCount += count;
    //       return `${p1}${highlightedText}${p3}`;
    //     });
    //     // totalCount += headResult.count;
    //     const paraResult = highlightText(item.para);
    //     getHighlightedText(item.head,textFind)
    //     totalCount += paraResult.count;
    //     const updatedPara = paraResult.highlightedText.replace(/(<span id="textRef">)(.*?)(<\/span>)/gi, (match, p1, p2, p3) => {
    //       const { highlightedText, count } = highlightText(p2);
    //       totalCount += count;
    //       return `${p1}${highlightedText}${p3}`;
    //     });
    //     // newItem.head = headResult.highlightedText;
    //     newItem.head = updatedHead
    //     newItem.para = updatedPara;
    //     return newItem;
    //   });
    //   setProcessedData(processed);
    //   // setData(processed)
    //   setTotalMatches(totalCount);

    let totalCount = 0;
    const processed = nestedArray.map((item) => {
      let newItem = { ...item };
      const headResult = highlightText(item.head, trimmedValue);
      totalCount += headResult.count;
      const paraResult = highlightText(item.para, trimmedValue);
      totalCount += paraResult.count;
      newItem.head = headResult.highlightedText;
      newItem.para = paraResult.highlightedText;
      return newItem;
    });
    setProcessedData(processed);
    setTotalMatches(totalCount);
  }
  const onChangeTextPlace = (e) => {
    setTextReplace('')
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextReplace(trimmedValue)
  }

  const onButtonReplace = () => {
    // setData(processedData)
    const successMsg = (message) => {
      return (
        <>
          <span style={{ fontSize: "12px" }}>{message}</span>
        </>
      );
    };
    let payloadArr = nestedArray.filter((item, index) => {
      if (regex.test(item.head) || regex.test(item.para)) {
        let newItem = item.head.replace(regex, (match) => `${textReplace}` + ` `)
        item.head = newItem
        let newItem2 = item.para.replace(regex, (match) => `${textReplace}` + ` `)
        item.para = newItem2;
        // payloadArr.push(item)
        return item;
      }
    })
    let newPayload = {
      soId: null,
      domainIds: null,
      data: payloadArr
    }
    if (payloadArr.length > 0) {
      setIsLoading(true);
      updateCmDomains(newPayload).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          toast.success(successMsg(res.data.message));
          // data.para = text;
          // data.head = ques;
          // data.relevant = payload.relevant;
          setIsLoading(false);
          // setIsEdit(false);
          setTextFind('')
          setTextReplace('')
          // setData(payloadArr)
        }
      })
    }
  }

  function flattenArray(nestedArray) {
    let flattenedArray = [];
    nestedArray.forEach(subArray => {
      flattenedArray = flattenedArray.concat(subArray);
    });
    setNestedArray(flattenedArray)
    return flattenedArray;
  }

  useEffect(() => {
    fetchData();
  }, [refreshData]);
  // console.log("isRelevant", isRelevant)
  return (
    <>
      {isLoading && (
        <div>
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
        </div>
      )}
      {!isLoading && (
        <div style={{ overflowY: 'auto' }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={Styles.header} style={{ width: "55%" }}>
              <span style={textStylesHeader}>Review Content</span>
              {/* <VizHeader type={"2"}>Review Content4</VizHeader> */}
            </div>
            <div style={{
              width: "45%",
              textAlign: "end",
            }}>
              <i
                className="fa fa-times-circle"
                onClick={() => isDrawerOpen(false)}
                style={{
                  // width: "45%",
                  fontSize: "24px",
                  color: "#dc2f02",
                  cursor: "pointer",
                  // textAlign: "end",
                }}
              ></i>
            </div>
          </div>
          <hr style={{ marginBottom: "0px" }} />
          <div
            className="mt-4 mb-2"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ width: "200px" }}>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Option"
                value={isRelevant} // can be string or object depending on your state
                onChange={(v) => {
                  // Find the full object
                  const selectedObj = relevantData.find(item => item.value === v);
                  setRelevant(selectedObj);
                  // console.log("Selected object:", selectedObj);
                }}
                options={relevantData}
              />
              {/* <MultiSelectCmTwo
                value={isRelevant}
                onChangeFunc={(e) => setRelevant(e)}
                isMulti={false}
                options={[
                  { name: "All", value: "All", label: "All" },
                  { name: "Non-Misc", value: "Non-Misc", label: "Non-Misc" },
                  {
                    name: "Reusable Thread QA",
                    value: "Reusable Thread QA",
                    label: "Reusable Thread QA",
                  },
                ]}
              /> */}
            </div>
          </div>
          {drawerState.obj.indexed === false && data.length > 0 &&
            <textarea
              wrap="soft"
              style={{
                border: '1px solid rgb(224, 226, 230)',
                width: '200px',            // same width as input
                height: '30px',            // same height as input
                // fontSize: '12px',
                borderRadius: '3px',
                outline: 'none',
                resize: 'none',
                padding: '0 8px',          // horizontal padding only
                lineHeight: '30px',        // ✅ centers text vertically
                boxSizing: 'border-box',
                overflow: 'hidden'   // ensures exact dimensions
              }}
              rows={1}
              placeholder="Replace From"
              autoComplete="off"
              value={textFind}
              name="name"
              onChange={(e) => onChangeTextFind(e)}
            />
          }
          {(textFind !== '' && drawerState.obj.indexed === false) && <><span style={{ fontSize: '12px' }}>{" "}Total Matches:{" "}{totalMatches}</span></>}
          {drawerState.obj.indexed === false && data.length > 0 &&
            <>
              <div style={{ marginTop: "8px" }}>
                {/* <></> */}
                {/* <input autoComplete="off" className="mb-1" placeholder="Replace To"
                  //  style={{ width: '200px', fontSize: '12px', borderRadius: '3px', border: '1px solid lightgrey', padding: '4px 8px' }} 
                  style={{
                    border: '1px solid lightgrey',
                    width: '200px',
                    fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    height: '30px',
                    // height:"30px",
                    // alignItems:"center",
                    // lineHeight: '30px',   // centers text vertically
                    padding: '0 8px',
                  }}

                  value={textReplace} onChange={(e) => onChangeTextPlace(e)} /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: '1px solid rgb(224, 226, 230)',
                    width: '200px',            // same width as input
                    height: '30px',            // same height as input
                    // fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    padding: '0 8px',          // horizontal padding only
                    lineHeight: '30px',        // ✅ centers text vertically
                    boxSizing: 'border-box',
                    overflow: 'hidden'   // ensures exact dimensions
                  }}
                  rows={1}
                  placeholder="Replace To"
                  autoComplete="off"
                  value={textReplace}
                  name="name"
                  onChange={(e) => onChangeTextPlace(e)}
                />
              </div>
              {((textFind !== '' && textReplace !== '' && totalMatches > 0) && drawerState.obj.indexed === false) &&
                <div className="mt-1 mb-2">
                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      cursor: "pointer",
                      //  font-weight: 400;			
                    }}
                  // disabled={disabled}
                  // disabled={disabled || editorState?.publishButtonBool}
                  // className="buttonDark"
                  >
                    Replace

                  </button>

                </div>}
              {
                ((textFind === '' || textReplace === '' || textFind && textReplace === '' || totalMatches === 0) && drawerState.obj.indexed === false) &&
                <div className="mt-1 mb-2">
                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      cursor: "not-allowed",
                      //  font-weight: 400;			
                    }}
                    // disabled={disabled}
                    disabled
                  // className="buttonDark"
                  >
                    Replace

                  </button>
                </div>
              }
            </>}
          <div style={{ padding: '5px' }}>
            {data.map((obj) => {
              return (
                <>
                  <SubContainer
                    imageData={inlineImageData}
                    data={obj}
                    refreshFunc={refresh}
                    isRelevant={isRelevant}
                    onButtonReplace={onButtonReplace}
                    textFind={textFind}
                    textReplace={textReplace}
                    onChangeTextFind={onChangeTextFind}
                    getHighlightedText={getHighlightedText}
                  />
                </>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
